import { IconButton, makeStyles } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { v4 } from "uuid";
import { icon_peopleMinus, icon_peoplePlus } from "../../../assets/images/images";
import { CancelCrudButtons } from "../../../components/ui/CancelCrudButtons";
import { InputField } from "../../../components/ui/InputField";
import { Modal } from "../../../components/ui/Modal"
import { TextArea } from "../../../components/ui/TextArea";
import { prettyDate } from "../../../config/dateFormatting"
import { IDishQuantiy, IUserOption } from "../../../interface/interface";
import { planEatApi } from "../../../planEatApi/PlanEatApi";
import { IBookingContent, IBookingItemContent, IDishContent, ISeatingContent, IUserContent, IVersionedObject } from "../../../planEatApi/PlanEatFacade"
import { ConfirmAddBookingModal } from "./ConfirmAddBookingModal";
import { IServiceUserInfo } from "../../../datasolvr/ServicesFacade";
import { extractErrorMessage } from "../../../components/utils/ErrorHandler";

const useStyles = makeStyles((theme: any) => ({
    title: {
        fontWeight: 'bold',
        marginBottom: 15,
    },
    inputSection: {
        marginBottom: 20
    },
    seatingsContainer: {
        display: 'flex',
        columnGap: 15,
    },
    seatingContainer:{
        display: 'flex',
        flexDirection: 'column',
        padding: 15,
        borderRadius: 8,

        "&:hover": {
            cursor: 'pointer',
            background: "rgba(0,0,0,0.05)"
        }
    },
    dishesContainer: {
        display: 'flex',
        rowGap: 15,
        flexDirection: 'row'
    },
    dishContainer: {
        display:'grid',
        gridTemplateColumns: '70% 30%',
        width: "50%",
        background: '#FFFFFF',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderLeft: '2px solid green',
        padding: 15,
    },
    numberOfPeopleContainer: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
        width: 'min-content',
        '& > *':{
            padding: 0
        }
    },
    numberOfPeopleInput: {
        outline: 'none',
        border: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        margin: 'auto',
        fontSize: 26,
        textAlign: 'center',
        width: 40,
        '& > *':{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            width: '100%'
        }
    },
    buttonsContainer: {
        display: 'flex',
        width: '100%',
        columnGap: 15,
        justifyContent: 'flex-end'
    }
}));

interface Props {
    hidden: boolean;
    setHidden: React.Dispatch<React.SetStateAction<boolean>>;
    date: Date;
    seatingsOnDate: IVersionedObject<ISeatingContent>[];
    users:  IVersionedObject<IUserContent>[];
    serviceUsers: IServiceUserInfo[];
}


export const AddBookingModal: React.FC<Props> = ({
    hidden,
    setHidden,
    date,
    seatingsOnDate,
    users,
    serviceUsers
}) => {
    const classes = useStyles()
    const [seating, setSeating] = useState<IVersionedObject<ISeatingContent>>()
    const [userOptions, setUserOptions] = useState<IUserOption[]>([])
    const [userId, setUserId] = useState('');
    const [dishesOnSeating, setDishesOnSeating] = useState<IVersionedObject<IDishContent>[]>([])
    const [dishQuantities, setDishQuantities] = useState<IDishQuantiy[]>([])
    const [comment, setComment] = useState("")
    const [isConfirmBookingHidden, setConfirmBookingHidden] = useState(true)

    useEffect(() => {
        if(!seating && seatingsOnDate.length > 0){
            setSeating(seatingsOnDate[0])
        }
    },[])

    useEffect(() => {
        if(hidden){
            setDishQuantities([])
            setDishesOnSeating([])
            setComment("")
            setUserId("")
            setSeating(undefined)
        }
    },[hidden])

    useEffect(() => {
        var tmpUserOptions: IUserOption[] = []
        users.forEach(user => {
            const serviceUser = serviceUsers.find(item => item.content.id === user.content.applicationUserId)

            if(serviceUser && serviceUser.content.name !== ""){
                var tmpUserOption: IUserOption = {
                    id: user.content.id,
                    name: user.content.applicationUserId
                }
                tmpUserOptions.push(tmpUserOption)
            }
        })
        setUserOptions(tmpUserOptions)
    },[users, serviceUsers])

    useEffect(() => {
        if(seating){
            planEatApi.getDishes()
            .then(response => {
                var tmpDishesOnSeating: IVersionedObject<IDishContent>[] = []
                response.data.forEach(dish => {
                    seating.content.seatingDishes.forEach(seatingDish => {
                        if(dish.content.id == seatingDish.dishId){
                            tmpDishesOnSeating.push(dish)
                        }
                    })
                })
                setDishesOnSeating(tmpDishesOnSeating)
            })
        }
    },[seating])

    useEffect(() => {
        var tmpDishQuantities: IDishQuantiy[] = []
        dishesOnSeating.forEach(dishOnSeating => {
            tmpDishQuantities.push({
                dish: dishOnSeating,
                quantity: 0
            })
        })
        setDishQuantities(tmpDishQuantities)
    },[dishesOnSeating])

    function updateDishQuantity(dishId: string, alterBy: number){
        var tmpDishQuantities: IDishQuantiy[] = []
        dishQuantities.forEach(dishQuantiy => {
            if(dishQuantiy.dish.content.id === dishId){
                tmpDishQuantities.push({
                    dish: dishQuantiy.dish,
                    quantity: dishQuantiy.quantity + alterBy
                })
            } else {
                tmpDishQuantities.push(dishQuantiy)
            }
        })
        setDishQuantities(tmpDishQuantities)
    }

    const handleQuantityChange = (dishId: string, strQuantity: string) => {
        var quantity = parseInt(strQuantity)
        if(Number.isNaN(quantity)){
            quantity = 0
        } else if(strQuantity.length > 1 && quantity === 0){
            quantity = 0
        } else if(quantity >= 99 || strQuantity.length > 2){
            quantity = 99
        } 

        var tmpDishQuantities: IDishQuantiy[] = []
        dishQuantities.forEach(dishQuantiy => {
            if(dishQuantiy.dish.content.id === dishId){
                tmpDishQuantities.push({
                    dish: dishQuantiy.dish,
                    quantity: quantity
                })
            } else {
                tmpDishQuantities.push(dishQuantiy)
            }
        })
        setDishQuantities(tmpDishQuantities)
    }

    function postBooking(){
        if(seating){
            let bookingItems: IBookingItemContent[] = []
            dishQuantities.forEach(dishQuantity => {
                for(var i=0;i<dishQuantity.quantity;i++){
                    const bookingItem: IBookingItemContent = {
                        'bookingItemId': v4(),
                        'dishId': dishQuantity.dish.content.id,
                        'dishVersion': dishQuantity.dish.version
                    };
                    bookingItems.push(bookingItem)
                }
            })
            var tmpUserId = users.find(user => user.content.applicationUserId === userId)
            if(tmpUserId){
                var booking: IBookingContent = {
                    id: '',
                    name: "",
                    description: "",
                    userId: tmpUserId?.content.id,
                    seatingId: seating.content.id,
                    seatingVersion: seating.version,
                    bookingPricePerServing: 0,
                    bookingComment: comment,
                    bookingItems: bookingItems,
                }
    
                planEatApi.postBooking(booking)
                .then(response => {
                    toast.success("Booking was create")
                    setHidden(true)
                    setConfirmBookingHidden(true)
                    setSeating(undefined)
                    setUserId("")
                    setDishQuantities([])
                    setComment("")
                })
                .catch(e => {
                    extractErrorMessage(e, "Failed creating booking")
                })
            }   
        }
    }

    function calculateQuantiy(){
        var quantity = 0
        dishQuantities.forEach(dishQuantity => quantity = quantity + dishQuantity.quantity)
        return quantity
    }

    return (
        <Modal title={"Add Booking(s) " + prettyDate(date,false,true)} hidden={hidden} setHidden={setHidden}>      
            {seatingsOnDate.length == 0 ?
                <div>
                    No seating(s) on the date
                </div>
                :
                <div>
                    <div className={classes.inputSection}>
                        <div className={classes.title}>Choose a seating</div>
                        <div className={classes.seatingsContainer}>
                            {seatingsOnDate.map((seatingOnDate,index) => 
                                <div 
                                    className={classes.seatingContainer} 
                                    onClick={() => {setSeating(seatingOnDate)}} 
                                    style={{background: seating?.content.id === seatingOnDate.content.id ? "rgba(0,0,0,0.1)" : ""}}>
                                    <b>{prettyDate(seatingOnDate.content.seatingStart,true,true)}</b> 
                                    <div>{seatingOnDate.content.seatingName}</div> 
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={classes.inputSection} style={!seating ? {opacity: 0.3, pointerEvents: 'none'} : undefined}>
                        <div className={classes.title}>Choose a user</div>
                        <div>
                            <Autocomplete
                                id="users"
                                options={userOptions}
                                renderInput={params => (
                                    <InputField {...params} label="Users" variant="outlined" />
                                )}
                                getOptionLabel={option => option.name}
                                style={{ width: "50%" }}
                                inputValue={userId}
                                onInputChange={(event, newInputValue) => {
                                    setUserId(newInputValue);
                                }}
                            />
                        </div>
                    </div>
                    <div className={classes.inputSection} style={!userId ? {opacity: 0.3, pointerEvents: 'none'} : undefined}>
                        <div className={classes.title}>Booking</div>
                        <div className={classes.dishesContainer}>

                            {dishQuantities.length > 0 ? dishQuantities.map(dishQuantity => 
                                <div className={classes.dishContainer}>
                                    <div>
                                        <b>{dishQuantity.dish.content.dishTitle}</b>
                                        <div>{dishQuantity.dish.content.dishDescription}</div>
                                    </div>
                                    <div className={classes.numberOfPeopleContainer}>
                                        <IconButton onClick={() => {updateDishQuantity(dishQuantity.dish.content.id, -1)}}>
                                            <img src={icon_peopleMinus}/>
                                        </IconButton>
                                        <input 
                                            className={classes.numberOfPeopleInput} 
                                            value={dishQuantity.quantity} 
                                            type="number"
                                            onChange={(e) => {handleQuantityChange(dishQuantity.dish.content.id, e.target.value)}} 
                                            onBlur={(e) => {e.target.value=== "" && handleQuantityChange(dishQuantity.dish.content.id, "0")}}>
                                        
                                        </input>
                                        <IconButton color="secondary" onClick={() => {updateDishQuantity(dishQuantity.dish.content.id, 1)}}>
                                            <img src={icon_peoplePlus}/>
                                        </IconButton>
                                    </div>
                                </div>
                            )
                            :
                            <div className={classes.dishContainer}>
                                <div style={{height: 48, display: "flex",alignItems: "center"}}>
                                    No dishes on selected seating
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    <div className={classes.inputSection} style={!userId ? {opacity: 0.3, pointerEvents: 'none'} : undefined}>
                        <div className={classes.title}>Comment</div>
                        <TextArea placeholder='Comments, notes etc' rows={2} defaultValue={comment} onBlur={(e) => {setComment(e.target.value)}} />
                    </div>
                    <div className={classes.inputSection}>
                        <CancelCrudButtons 
                            hidden={hidden} 
                            setHidden={setHidden} 
                            isDelete={false} 
                            postEntity={() => setConfirmBookingHidden(false)}
                            postButtonText={"Create Booking"}
                            disabledPostButton={dishQuantities.find(dishQuantity => dishQuantity.quantity > 0) === undefined}/>
                    </div>
              
                </div>
            }
            <ConfirmAddBookingModal 
                hidden={isConfirmBookingHidden} 
                setHidden={setConfirmBookingHidden}
                postBooking={postBooking}      
                userId={userId}
                date={date}
                quantity={calculateQuantiy()}
                seatingName={seating ? seating?.content.seatingName : ""}
            />
        </Modal>
    )
}